
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IGame } from '~/store/games/types';

@Component
export default class GameMobilePlaytestButton extends Vue {
  @Prop(Object) readonly game!: IGame;
  @Prop(String) readonly platform!: string;
  @Prop({ type: String, default: 'medium-font' })
  readonly largeScreenFontSize!: IGame;

  androidIcon: any = require('~/assets/icons/icon_android.svg');
  iosIcon: any = require('~/assets/icons/icon_apple.svg');

  buttonText() {
    const p = this.platform;
    return {
      icon: p == 'android' ? this.androidIcon : this.iosIcon,
      text: this.$t(`components.games.mobilePlaytestButton.${p}`),
    };
  }

  getPlatformDownloadLink() {
    return this.platform == 'android'
      ? this.game.apkLink
      : this.game.iOSDownloadLink;
  }

  trackEvent() {
    if (this.platform == 'android') {
      this.$ua.trackApkDownloadEvent({
        game: this.game.name,
      });
    }
    if (this.platform == 'ios') {
      this.$ua.trackIosDownloadEvent({
        game: this.game.name,
      });
    }
  }

  goTo(url: string | undefined) {
    // UA tracking (update to new mobile playtest event)
    this.trackEvent();
    window.location.href = url || window.location.href;
  }
}
